import { useEffect, useState } from 'react'

const QUERY = {
  MOBILE: `(min-width:1px) and (max-width:768px)`, // mobile
  DESKTOP: `(min-width:769px)`,
} as const

/**
 * ```ts
 * const mobile = useMeidaQuery('MOBILE');
 * // "MOBILE" 조건에 부합하면(true) 부합하지않으면(false)
 * ```
 */
export default function useMediaQuery(key: keyof typeof QUERY) {
  const mediaQuery = window.matchMedia(QUERY[key])
  const [match, setMatch] = useState<boolean>(() => !!mediaQuery.matches)

  useEffect(() => {
    const change = () => setMatch(!!mediaQuery.matches)

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener(`change`, change)
    } else {
      // Deprecated 'MediaQueryList' API, <Safari 14, IE, <Edge 16
      mediaQuery.addListener(change)
    }
    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', change)
      } else {
        mediaQuery.removeListener(change)
      }
    }
  }, [mediaQuery])

  return match
}
